<template>
    <div id="app">
        <router-view></router-view>
        <!--        <div style="height:1rem;">-->
        <van-tabbar class="vati" :safe-area-inset-bottom="false" route active-color="#00ACEF" v-if="isTabShow">
            <van-tabbar-item replace :to="'/home'" icon="wap-home-o">首页</van-tabbar-item>
            <van-tabbar-item replace :to="'/appointment'" icon="todo-list-o">预约管理</van-tabbar-item>
            <van-tabbar-item replace :to="'/fbs'" v-if="userType==1||userType==2">
                <div style="width: 30px" >
                    <div class="saomabtn">
                        <div class="smbt">
                            <img src="./assets/fanboshi.png">
                        </div>
                    </div>
                </div>
            </van-tabbar-item>
            <van-tabbar-item replace :to="'/msg'" icon="chat-o">消息提醒</van-tabbar-item>
            <van-tabbar-item replace :to="'/my'" icon="manager-o">我的</van-tabbar-item>
        </van-tabbar>
        <!--        </div>-->
    </div>
</template>
<script>
    import TabBar from "./views/components/TabBar"
    import TabBarItem from "./views/components/TabBarItem"
    import {getCookie} from "./utils/auth";

    export default {
        data() {
            return {
                ws: null,
                isTabShow: true,
                fwUser: {},
                userType: '',
            }
        },
        components: {
            TabBar,
            TabBarItem,
        },
        created() {
            document.title = "数字智慧助手"
        },

        watch: {
            "$route": function (to) {
                if (getCookie("fwUser")) {
                    this.fwUser = JSON.parse(getCookie("fwUser"))
                    if (this.fwUser && this.fwUser.userType) {
                        this.userType = this.fwUser.userType
                    }
                }
                var tabArr = ["/home", "/appointment", "/msg", "/my","/fbs"];
                if (tabArr.includes(to.path)) {
                    this.isTabShow = true
                } else {
                    this.isTabShow = false
                }
            }
        },
        methods: {
        },
        computed: {}
    }
</script>

<style lang="scss">
    body,
    html {
        height: 100%;
    }

    #app {
        font-family: "PingFang SC", "微软雅黑", Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
        height: 100%;
    }

    .form-container .cube-radio-group {
        padding: 10px 50px;
        border-bottom: 1px #d1d1d1 solid;
    }

    .form-container .cube-radio {
        width: 50%;
        box-sizing: border-box;
        display: inline-block;
    }

    .form-container .cube-radio:first-child {
        border-right: 1px #ccc solid
    }

    .form-container .cube-radio-wrap {
        padding: 4px 0
    }

    input:focus {
        outline: none;
    }

    .border-bottom-1px::after {
        border: none
    }

    .saomabtn {
        width: 51px;
        height: 51px;
        border-radius: 45px;
        position: absolute;
        bottom: 15px;
        left: 50%;
        margin-left: -25px; /* 盒子宽度的一半 */
        z-index: 999;
    }

    .smbt {
        width: 49px;
        height: 49px;
        padding: 1px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    /*.saomatext {*/
    /*    font-size: 9px;*/
    /*    text-align: center;*/
    /*    color: #ffffff;*/
    /*    display: inline-block;*/
    /*    width: 100%;*/
    /*}*/

    /*.vati .van-tabbar-item__icon {*/
    /*    position: relative;*/
    /*    margin-bottom: 6px;*/
    /*    font-size: 0.58667rem;*/
    /*}*/

</style>
